import { PrinterOutlined } from '@ant-design/icons';
import { ServiceHistoryStatus } from '@services';
import { Button, Checkbox, Modal, Space, Typography } from 'antd';
import React, { useEffect, useState } from 'react';

const HISTORY_TYPES: ServiceHistoryStatus[] = ['Umoto', 'Imported', 'Unverified'];

interface IProps {
  open: boolean;
  onClose: () => void;
  vin: string;
}

export const PrintSelectionModal: React.FC<IProps> = ({ open, onClose, vin }) => {
  const [selectedTypes, setSelectedTypes] = useState<Set<ServiceHistoryStatus>>(
    new Set(HISTORY_TYPES)
  );
  const [typeError, setTypeError] = useState<string | null>(null);

  useEffect(() => {
    if (open) {
      setSelectedTypes(new Set(HISTORY_TYPES));
      setTypeError(null);
    }
  }, [open]);

  const handleTypeToggle = (type: ServiceHistoryStatus) => {
    setSelectedTypes((prev) => {
      const next = new Set(prev);
      if (next.has(type)) next.delete(type);
      else next.add(type);
      return next;
    });
    setTypeError(null);
  };

  const handlePrint = () => {
    if (selectedTypes.size === 0) {
      setTypeError('At least one history type must be selected');
      return;
    }
    const statuses = Array.from(selectedTypes).join(',');
    window.open(`/service-history/${vin}?statuses=${statuses}`, '_blank', 'noopener,noreferrer');
    onClose();
  };

  return (
    <Modal
      open={open}
      title="Print service history"
      onCancel={onClose}
      width={400}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button
          key="print"
          type="primary"
          icon={<PrinterOutlined />}
          onClick={handlePrint}
          disabled={selectedTypes.size === 0}
        >
          Print
        </Button>,
      ]}
    >
      <Space direction="vertical" size={12} style={{ width: '100%' }}>
        <Typography.Text>Select history types to include:</Typography.Text>
        <Space direction="vertical" size={8}>
          {HISTORY_TYPES.map((type) => (
            <Checkbox
              key={type}
              checked={selectedTypes.has(type)}
              onChange={() => handleTypeToggle(type)}
            >
              {type}
            </Checkbox>
          ))}
        </Space>
        {typeError && (
          <Typography.Text type="danger">{typeError}</Typography.Text>
        )}
      </Space>
    </Modal>
  );
};
